<!-- eslint-disable vue/require-explicit-emits -->
<template>
  <iRow
    :class="{
      ...classList,
      'empty-layout': isEmpty && !hasABorder,
      'root-layout': isRootLayout,
      'layout': true
    }"
    v-bind="{
      ...myLayoutProps,
      'data-identifier': identifier,
      'data-parent-id': identifier,
      'draggable': editMode && isDraggable(identifier, configuration) && !breakpoint
    }"
    v-on="myEventListeners"
  >
    <Teleport to="body">
      <DynamicComponentContextualMenu
        v-if="(isDynamicAppComponent ? true : canEditPublication)
          && showContextualMenu
          && contextMenuFixedPositionStyle.top
          && contextMenuFixedPositionStyle.left"
        ref="contextualMenu"
        v-bind="contextMenuAttrs"
        v-on="contextMenuEvents"
      />
    </Teleport>
    <div
      v-if="canResizeHorizontally && (mouseOver || selectedHoverBorder)"
      class="resize-handle left"
      @mousedown.stop="handleMouseDownResize($event, 'left')"
    />
    <div
      v-if="canResizeHorizontally && (mouseOver || selectedHoverBorder)"
      class="resize-handle right"
      @mousedown.stop="handleMouseDownResize($event, 'right')"
    />
    <div
      v-if="canResizeVertically && (mouseOver || selectedHoverBorder)"
      class="resize-handle top"
      @mousedown.stop="handleMouseDownResize($event, 'top')"
    />
    <div
      v-if="canResizeVertically && (mouseOver || selectedHoverBorder)"
      class="resize-handle bottom"
      @mousedown.stop="handleMouseDownResize($event, 'bottom')"
    />
    <slot />
  </iRow>
</template>

<script>
import { LayoutElementMixin } from "%/dynamic-component-editor/standard-elements/layouts/layout-element-mixin";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import BackgroundOptions from "%/dynamic-component-editor/bundles/background-options";
import HorizontalLayoutPositionOptions from "%/dynamic-component-editor/bundles/horizontal-layout-position-options";
import DynamicComponentContextualMenu from "%/dynamic-component-editor/components/DynamicComponentContextualMenu.vue";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import PositioningOptions from "%/dynamic-component-editor/bundles/positioning-options";
import EffectsOptions from "%/dynamic-component-editor/bundles/effects-options";
import AnimationEffectsOptions from "%/dynamic-component-editor/bundles/animation-effects-options";

export default {
  name: "HorizontalContainer",
  components: { DynamicComponentContextualMenu },
  mixins: [LayoutElementMixin],
  elementPanelSettings: {
    tags: ["container", "layout", "row", "horizontal", "group"],
    displayName: "Horizontal Container",
  },
  deprecated: true,
  optionBundles: [
    PositioningOptions,
    new HorizontalLayoutPositionOptions({
      "default.layout-direction": "horizontal",
      "default.layout-width": "fill",
      "default.layout-height": "hug",
    }),
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
    AnimationEffectsOptions,
    new EffectsOptions({}, {
      "text-shadow": true,
    }),
    SpacingOptions,
    BackgroundOptions,
  ],
};
</script>
